import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { LoginService } from "../../../../login/services/login.service";

@Component({
  selector: "ab-payment-cancelled",
  templateUrl: "./payment-cancelled.component.html",
  styleUrls: ["./payment-cancelled.component.scss"]
})
export class PaymentCancelledComponent implements OnInit, OnDestroy {
  @Input() returnUrl: string;

  constructor(private loginService: LoginService) {}

  ngOnInit(): void {
    this.loginService?.logout().subscribe((response) => {});
  }

  closePayment() {
    if (window && window.location) {
      window.location.href = this.returnUrl;
    }
  }

  ngOnDestroy(): void {}
}
